import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import esTranslations from "app/locales/es/translation.json";

// eslint-disable-next-line import/no-named-as-default-member
i18n.use(initReactI18next).init({
  fallbackLng: "es",
  lng: "es",
  ns: ["translation"],
  defaultNS: "translation",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    es: {
      translation: esTranslations,
    },
  },
});

export default i18n;
